import React from 'react';
import Slider from 'react-slick';
import { Button } from './Button';
import './ExperienceSlideshow.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function AwardsSlideshow() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  const awards = [
    {
      image: "/images/Experience/google_ai_essentials.png",
      title: "Google AI Essentials | Google | Coursera",
      date: "July 2026",
      details: [
        "Those who earn the Google AI Essentials Certificate, developed by Google, have demonstrated their competence in integrating AI into their work. Through hands-on activities and assessments, graduates develop a foundational understanding of AI principles and practical proficiency in applying generative AI tools to workplace tasks, including writing effective prompts and using AI responsibly."
      ],
      button: {
        text: "View Credential",
        link: "https://www.credly.com/badges/927c10be-454c-40ee-a14a-e509e2dbe67c/public_url"
      }
    },
    {
      image: "/images/Experience/Schulich.png",
      title: "Global Experience in Software Engineering | University of Calgary (Cambridge, UK)",
      date: "Feb 2025",
      details: [
        "Participated in a global software engineering experience hosted at Cambridge, UK, through the University of Calgary. Engaged in an intensive international academic environment focused on software engineering principles, collaborative project work, and cross-cultural professional development."
      ]
    },
    {
      image: "/images/HabitCircle.jpg",
      title: "Alberta Health Hackathon 3rd Place Winner | Arcurve & ACHF",
      date: "Jul 2024",
      details: [
        "Earned 3rd place at the Alberta Health Hackathon, sponsored by Arcurve and the Alberta Children's Hospital Foundation (ACHF). Developed HabitCircle, a gamified habit-tracking app designed to support youth undergoing rehabilitation and mental health recovery. Prize money was donated to Alberta Children's Hospital."
      ],
      button: {
        text: "View Project",
        link: "https://devpost.com/software/habitcycle"
      }
    },
    {
      image: "/images/Experience/AIFundamentals.png",
      title: "Artificial Intelligence Fundamentals | IBM SkillsBuild",
      date: "Sept 2024",
      details: [ "Exploring the evolution of AI from its historical milestones to modern advancements, with a focus on machine learning and data analysis techniques that drive predictions and decisions. Demonstrated expertise in natural language processing, image analysis, and generative AI, highlighting how neural networks power innovative applications. Designed ethical AI models in IBM Watson Studio, ensuring minimal bias, aligning solutions with responsible AI principles, and identifying career opportunities and essential skills in the AI field." ],
      button: {
        text: "View Credential",
        link: "https://www.credly.com/badges/9f4cba7a-6446-40f1-9122-e0bcc3fe6df4/public_url"
      }
    },
    {
      image: "/images/Experience/WebDevFundamentals.png",
      title: "Web Development Fundamentals Credential | IBM SkillsBuild",
      date: "Mar 2024",
      details: [ "Demonstrating proficiency in front-end and back-end development, with a strong understanding of the software development lifecycle, agile methodologies, and the interplay of HTML, CSS, and JavaScript in creating dynamic web applications. Explored techniques for integrating JavaScript into HTML, managing data with MySQL, and applying robust testing strategies, including automated testing, version control, and responsive design principles to ensure quality. Applied advanced practices like DevOps and continuous delivery for seamless web deployment while identifying key career opportunities and essential skill sets in web development." ],
      button: {
        text: "View Credential",
        link: "https://www.credly.com/badges/6a0adff7-21be-4060-8802-bc397cfef050/public_url"
      }
    },
    {
      image: "/images/Experience/AB.png",
      title: "Jason Lang Scholarship | University of Calgary",
      date: "Oct 2023",
      details: [
        "Received the Jason Lang Scholarship due to outstanding academic achievements and received $1000 in recognition of excellence in undergraduate studies."
      ]
    },
    {
      image: "/images/Experience/leadership.png",
      title: "Foundations Tier | Engineering Leadership Certificate | University of Calgary",
      date: "Apr 2022",
      details: [
        "Acquired foundational leadership skills, including self-awareness, effective communication, and teamwork, through engaging in core workshops and events."
      ],
      button: {
        text: "View Credential",
        link: "https://badges.ucalgary.ca/achievements/627d3efa0f59cdee9e664379320ec5d8"
      }
    },
    {
      image: "/images/Experience/Entrepreneurship.png",
      title: "Innovation and Core Concepts of Engineering Entrepreneurship Certificate | University of Calgary",
      date: "Oct 2022",
      details: [
        "Immersed in core concepts of innovation and engineering entrepreneurship, gaining an understanding of the entrepreneurial journey, developing a mindset to recognize opportunities, and creating business models. Built key interpersonal skills, including forming a startup team, mastering project management essentials, and enhancing communication, teamwork, adaptability, and resilience.",
      ],
      button: {
        text: "View Credential",
        link: "https://badges.ucalgary.ca/1786d1d78fac536b666e05d58dadbd00"
      }
    },
    {
      image: "/images/Experience/Schulich.png",
      title: "Diversity Champions in Engineering Award | Schulich School of Engineering",
      date: "Sept 2021",
      details: [
        "Promoted diversity and inclusivity in engineering within the University of Calgary community and received a monetary award of $4000 in recognition of contributions."
      ]
    },
    {
      image: "/images/Experience/glenbow.png",
      title: "Recognition Award | Glenbow Construction Company",
      date: "Sept 2021",
      details: [
        "Received a recognition award from Glenbow Construction Company in acknowledgement of high performance, versatility, adaptability and multitasking"
      ]
    }
  ];

  return (
    <div className="slideshow-container">
      <Slider {...settings}>
        {awards.map((award, index) => (
          <div key={index} className="slide">
            {award.image && (
              <img
                src={award.image}
                alt={award.title}
                className="slide-image"
              />
            )}
            <div className="slide-description">
              <div className="text-container">
                <h2 className="role-title">{award.title}</h2>
                <div className="awardDate">{award.date}</div>
                <div className="description">
                  {award.details.map((detail, idx) => (
                    <p key={idx}>{detail}</p>
                  ))}
                </div>
                {award.button && (
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <Button
                      className='btns'
                      buttonStyle='btn--download'
                      buttonSize='btn--large'
                      linkTo={award.button.link}
                      external
                    >
                      {award.button.text} <i className='fas fa-arrow-right' />
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default AwardsSlideshow;
